<template>
  <div>
    <h2>利用規約</h2>
    <div id="term_text">
      <h3>1. ご飯を食べるときの約束</h3>
      <p>
        頂きますといいましょう。<br>
        言わない場合はご飯抜きです。<br>
        美味しくご飯を食べるために協力してください。
      </p>
      <h3>2. ご飯を食べるときの約束</h3>
      <p>
        頂きますといいましょう。<br>
        言わない場合はご飯抜きです。<br>
        美味しくご飯を食べるために協力してください。
      </p>
      <h3>3. ご飯を食べるときの約束</h3>
      <p>
        頂きますといいましょう。<br>
        言わない場合はご飯抜きです。<br>
        美味しくご飯を食べるために協力してください。
      </p>
      <h3>4. ご飯を食べるときの約束</h3>
      <p>
        頂きますといいましょう。<br>
        言わない場合はご飯抜きです。<br>
        美味しくご飯を食べるために協力してください。
      </p>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Term'
  }
</script>

<style scoped lang="scss">
  h2{
    text-align: center;
  }
  #term_text{
    width: 90%;
    margin: 10px 0 0 5%;
  }
</style>